import React from 'react'
import Navbar from '../Navbar';
import Footer from '../Footer';
import investerBanner from '../../assests/investor relationship/handshake.webp';
import '../../hamcss/investor.css';
import { useState } from 'react'
import { FaRegFilePdf } from "react-icons/fa";
import { Link } from 'react-router-dom';

import fy24a from '../../assests/sgPdf/credit_rating/FY 2024-25/CP-ICRA_Rating disclsoure.pdf';
import fy24b from '../../assests/sgPdf/credit_rating/FY 2024-25/CRISIL Rating.pdf';
import fy24c from '../../assests/sgPdf/credit_rating/FY 2024-25/ICRA Rating_29.11.2024.pdf';
import fy24d from '../../assests/sgPdf/credit_rating/FY 2024-25/BSE disclosure_ICRA Rating_30.12.2024.pdf';
import fy24e from '../../assests/sgPdf/credit_rating/FY 2024-25/CRISIL_Rating confirmation-21.03.2025.pdf';
import fy25a from '../../assests/sgPdf/credit_rating/FY 2025-26/ICRA Rating confirmation_04.04.2025.pdf';
import fy25b from '../../assests/sgPdf/credit_rating/FY 2025-26/CRISIL Confirmation_17.04.2025.pdf';
import fy25c from '../../assests/sgPdf/credit_rating/FY 2025-26/CRISL Rating confirmation-25.04.2025.pdf';
import fy25d from '../../assests/sgPdf/credit_rating/FY 2025-26/ICRA_27.05.2025.pdf';
import fy25e from '../../assests/sgPdf/credit_rating/FY 2025-26/CRISIL Rating updated-25.07.2025.pdf';
import fy25f from '../../assests/sgPdf/credit_rating/FY 2025-26/CRISIL Confirmation_30.09.2025.pdf';
import fy25g from '../../assests/sgPdf/credit_rating/FY 2025-26/ICRA Rating_13.10.2025.pdf';
import fy25h from '../../assests/sgPdf/credit_rating/FY 2025-26/ICRA Credit Rating Confirmation_06-03-2026.pdf';
import fy25i from '../../assests/sgPdf/credit_rating/FY 2025-26/ICRA Credit Rating_23-12-2025.pdf';
import fy26a from '../../assests/sgPdf/credit_rating/FY 2026-27/Credit Rating_22.09.2026.pdf';
const CreditRating = () => {

    const [selectedOption, setSelectedOption] = useState("option00"); // State to track selected option

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value); // Update selected option when changed
    };


    return (
        <>

            <Navbar />
            <section>
                <div className="BreadArea" style={{
                    //  for /beta server 
                    backgroundImage: `url(${investerBanner})`,
                    // backgroundImage: "url('images/Bread.png')",
                }}>
                    <div className="container">
                        <h2>Credit-rating</h2>
                    </div>
                </div>
            </section>


            <section className="main-an">

                <div className="main-an-box">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 className='h2-text'>Credit-rating </h2>
                        <div>
                            <select className="select-class" onChange={handleOptionChange}>
                                <option value="option00">FY 2026-27</option>
                                <option value="option">FY 2025-26</option>
                                <option value="option0">FY 2024-25</option>




                            </select>
                        </div>
                    </div>

                    <div style={{ marginTop: '50px' }}>
                        {/* Conditionally render PDFs based on selected option */}
                        {selectedOption === "option00" && (
                            <>

                              
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26a} target='blank'>  <h6>Credit Rating_22.09.2026</h6> </a>
                                </div>
                                

                            </>

                        )}

                        {selectedOption === "option" && (
                            <>

                              

                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25a} target='blank'>  <h6>ICRA Rating confirmation_04.04.2025  </h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25b} target='blank'>  <h6>CRISIL Confirmation_17.04.2025  </h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25c} target='blank'>  <h6>CRISL Rating confirmation-25.04.2025  </h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25d} target='blank'>  <h6>ICRA_27.05.2025  </h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25e} target='blank'>  <h6>CRISIL Rating updated-25.07.2025  </h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25f} target='blank'>  <h6>CRISIL Confirmation_30.09.2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25g} target='blank'>  <h6>ICRA Rating_13.10.2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25h} target='blank'>  <h6>ICRA Credit Rating Confirmation_06-03-2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25i} target='blank'>  <h6>ICRA Credit Rating_23-12-2025</h6> </a>
                                </div>
                                
                                

                            </>

                        )}

                        {selectedOption === "option0" && (
                            <>

                              

                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24b} target='blank'>  <h6>CRISIL Rating  </h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24a} target='blank'>  <h6>CP-ICRA_Rating disclsoure  </h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24c} target='blank'>  <h6>ICRA Rating_29.11.2024  </h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24d} target='blank'>  <h6>BSE disclosure_ICRA Rating_30.12.2024 </h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24e} target='blank'>  <h6>CRISIL_Rating confirmation-21.03.2025 </h6> </a>
                                </div>
                                

                               




                            </>

                        )}



                        




                    </div>
                </div>

            </section>



            <Footer />


        </>
    )
}



export default CreditRating